import { Observable, BehaviorSubject } from 'rxjs';
import { GenericResource } from './store.interface';


// @TODO We hebben een slimme filter functie nodig, of op de state$ observable, of in een aparte functie

export class Store<T extends GenericResource> {

  private _state$: BehaviorSubject<T[]> = new BehaviorSubject([]);
  public state$: Observable<T[]> = this._state$.asObservable();

  protected constructor() {

  }

  get state(): T[] {
    return this._state$.getValue();
  }

  set state(nextState: T[]) {

    // remove all inactive items
    nextState = nextState.filter(el => el.active);

    this._state$.next(nextState);
  }

  /**
   * Shorthand function for state setter.
   */
  public setState(nextState: T[]): void {
    this.state = nextState;
  }

  /**
   * Insert item.
   */
  public insert(item: T): void {
    this.state.push(item);

    this.setState(this.state);
  }

  /**
   * Get one by id.
   *
   * @param id: Get item by id.
   */
  public queryOne(id: T['_id']): T {
    return this.state.find(item => item['_id'] === id);
  }

  /**
   * Shorthand for queryOne, get one by ID
   * @param id .
   */
  public get(id: T['_id']): T {
    return this.state.find(item => item['_id'] === id);
  }

  /**
   * Return all objects
   */
  public getAll() {
    return this.state;
  }

  /**
   * Updates if it finds an item by the ID, if not it inserts.
   *
   * @param item Item to upsert.
   */
  public upsert(item: T): void {
    const selectedItem = this.queryOne(item._id);
    if (selectedItem) {
      this.update(item);
    } else {
      this.insert(item);
    }
  }

  /**
   * Given an instance of data updates this by ID.
   *
   * @param updateItem Item to update.
   */
  public update(updateItem: Partial<GenericResource>): T {
    const selectedItem = this.queryOne(updateItem._id);

    // Fix for issue when an item has been added to new datastore, but is unknown in *this* datastore.
    if (!selectedItem) {
      return;
    }

    Object.assign(selectedItem, updateItem);
    // If there's orderinformation make sure it is adhered
    if (selectedItem['order']) {
      this.state.sort((a, b) => a['order'] > b['order'] ? 1 : b['order'] > a['order'] ? -1 : 0 );
    }

    this.setState(this.state);
    // Return the full newly updated object
    return selectedItem;
  }

  /**
   * Sets the data for item to active=false for matching deleteItemId.
   *
   * @param id Delete item by id.
   */
  public delete(id: T['_id']): T {

    const selectedItem = this.queryOne(id);
    Object.assign(selectedItem, { _id: id, active: false });

    this.setState(this.state);

    return selectedItem;
  }

  /**
   * Query.
   */
  public query() {
    // @TODO filter op observable
  }

  /**
   * get all related items
   */
  public getByRelated(relationName: string, relationId: string) {
    return this.state.filter(item => item[relationName + 'Id'] === relationId);
  }

  /**
   * Refresh - call to trigger all subscribers again.
   */
  public refresh(): void {
    this._state$.next(this.state);
  }


  /**
   * Order the items in this store by a list of ids
   * @param orderedIds .
   */
  order(orderedIds) {
    this.state.sort((a, b) => orderedIds.indexOf(a._id) - orderedIds.indexOf(b._id));

    this._state$.next(this.state);
  }

}
